/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";
import { generateApiUrl, createDateFormat } from "@/shared/utils";

export const getOneParvandeh = async (code) => {
  try {
    const url = generateApiUrl(["profile", "parvandehId"], [code]);
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const name = pathOr("", ["person", "name"], data);
    const family = pathOr("", ["person", "family"], data);

    return {
      code: pathOr(null, ["code"], data),
      parvandehNumber: pathOr(null, ["parvandeh_number"], data),
      fullName: `${name} ${family}`,
      totalItem: pathOr(null, ["total_item"], data),
      incompleteItem: pathOr(null, ["incomplete_item"], data),
      nationalCode: pathOr(null, ["person", "national_code"], data),
      mobile: pathOr(null, ["person", "mobile"], data),
      createdBy: pathOr(null, ["created_by"], data),
      createdAt: createDateFormat(pathOr(null, ["created_at", "jalali"], data)),
      roles: pathOr([], ["role"], data),
      statusEndReason: pathOr(null, ["status_end_reason", "caption"], data),
      cancelDescription: pathOr(null, ["cancel", "description"], data),
      cancelDate: pathOr(null, ["cancel", "cancel_at", "jalali"], data),
      tags: pathOr([], ["tags"], data),
      description: pathOr(null, ["comment"], data),
      termCaption: pathOr(null, ["term", "caption"], data),
    };
  } catch (error) {
    throw error;
  }
};

export const refreshParvandehStatus = async () => {
  try {
    const url = generateApiUrl(["profile", "refresh_parvandeh_status"]);
    const response = await httpService.patch(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const addManualParvandehForNewUser = async (
  termCode,
  name,
  family,
  genderId,
  mobile,
  nationalCode,
  password
) => {
  try {
    const url = generateApiUrl(["profile", "form_manual_register"]);
    const payload = {
      term_code: termCode,
      name,
      family,
      gender_id: genderId,
      mobile,
      national_code: nationalCode,
      password,
      password_confirmation: password,
    };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const addManualParvandehForActiveUser = async (
  userCode,
  termCode,
  description
) => {
  try {
    const url = generateApiUrl(["profile", "parvandeh"]);
    const payload = {
      user_code: userCode,
      term_id: termCode,
      comment: description,
    };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const getAllParvandehRoleHistory = async (
  code,
  page = 1,
  getPerPage = 10
) => {
  try {
    const queryString = { page, per_page: getPerPage };
    const url = generateApiUrl(
      ["profile", "parvandeh_role_log"],
      [code],
      queryString
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const total = pathOr(0, ["total"], data);
    const count = pathOr(0, ["count"], data);
    const totalPages = pathOr(0, ["total_pages"], data);
    const currentPage = pathOr(1, ["current_page"], data);
    const perPage = pathOr(10, ["per_page"], data);
    const items = pathOr([], ["result"], data);

    return { total, count, totalPages, currentPage, perPage, items };
  } catch (error) {
    throw error;
  }
};

export const moveParvandehToArchive = async (code, reasonId) => {
  try {
    const url = generateApiUrl(["profile", "parvandehId"], [code]);
    const payload = {
      status: 2,
      status_end_reason_id: reasonId,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const moveArchiveToParvandeh = async (code) => {
  try {
    const url = generateApiUrl(["profile", "parvandehId"], [code]);
    const payload = {
      status: 1,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const updateParvandeh = async (code, description, tags) => {
  try {
    const url = generateApiUrl(["profile", "parvandehId"], [code]);
    const payload = {
      comment: description,
      tag_id: tags,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const editParvandehRole = async (code, roleCodes) => {
  try {
    const url = generateApiUrl(["profile", "parvandehRole"], [code]);
    const payload = { role_codes: roleCodes };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);
    return { message };
  } catch (error) {
    throw error;
  }
};
